import React, { Component } from "react";
import { Switch } from "react-router";
import { PublicPage } from "../pages/public-page/PublicPage";
import { Layout } from "./Layout";
import { RouteWithLayout } from "./RouteWithLayout";

export class DefaultSwitch extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout layout={Layout} exact path="/" component={PublicPage} />
      </Switch>
    );
  }
}
